import api from './api'

export interface TenantBrandingData {
  logo_url: string
  company_name: string
  short_name: string
  company_location: string
  company_address: string
  company_city: string
  company_state: string
  company_postal_code: string
  company_country: string
  company_cr: string
  company_vat: string
  updated_at?: string | null
}

export type TenantBrandingPatch = {
  logo_url?: string | null
  company_name?: string | null
  short_name?: string | null
  company_location?: string | null
  company_address?: string | null
  company_city?: string | null
  company_state?: string | null
  company_postal_code?: string | null
  company_country?: string | null
  company_cr?: string | null
  company_vat?: string | null
}

export async function getTenantBranding(): Promise<TenantBrandingData> {
  const response = await api.get<{ success: boolean; data: TenantBrandingData }>(
    '/api/v1/settings/branding'
  )
  return response.data.data
}

export async function patchTenantBranding(
  body: TenantBrandingPatch
): Promise<TenantBrandingData> {
  const response = await api.patch<{ success: boolean; data: TenantBrandingData }>(
    '/api/v1/settings/branding',
    body
  )
  return response.data.data
}
